import React from 'react'
import styled from '@emotion/styled'
import { Divider, Stack, Typography } from '@mui/material'
import { Inputs } from '../../../containers/facilityReservationTodayConditionInput/facilityReservationTodayConditionInputService'
import { Control } from 'react-hook-form'
import { GetTodayConditionInputDetailDto } from '../../../dataAccess/webApi/dto/reservationsDto'
import { GContainer, GItem } from '../common/grids'
import { TitleLabel } from '../common/titleLabel'
import { AttentionLabel } from '../common/attentionLabel'
import { Select } from '../common/inputs/select'
import { NumberBox } from '../common/inputs/numberBox'
import { PostDecodeMstDto } from '../../../dataAccess/webApi/dto/decodeMstDto'
import {
  todayConditionInputFieldUsage,
  todayConditionDefecationTiming,
} from '../../../containers/common/constant/classification'
import { translate } from '../../../i18n'

const SectionText = styled(Typography)(() => ({
  fontSize: '21px',
  marginTop: '10px',
}))

const BlackDivider = styled(Divider)(() => ({
  borderColor: '#000',
  marginBottom: '20px',
}))

type DefecationSecProps = {
  control: Control<Inputs>
  todayConditionInputFieldsInfo: GetTodayConditionInputDetailDto['todayConditionInputFieldsInfo']
  defecationTimingDecodeMst: PostDecodeMstDto[]
  defecationConditionDecodeMst: PostDecodeMstDto[]
  defecationTiming: string | null
}

// 排便セクション
const DefecationSec: React.FC<DefecationSecProps> = (props) => {
  const {
    control,
    todayConditionInputFieldsInfo,
    defecationTimingDecodeMst,
    defecationConditionDecodeMst,
    defecationTiming,
  } = props

  // 排便タイミング用の選択肢オプションを編集
  const defecationTimingValueLabels = defecationTimingDecodeMst.map((item) => {
    return {
      value: item.code,
      label: item.name,
    }
  })

  // 便の状態用の選択肢オプションを編集
  const defecationConditionValueLabels = defecationConditionDecodeMst.map((item) => {
    return {
      value: item.code,
      label: item.name,
    }
  })

  return (
    <GItem xs={12}>
      {/* セクションタイトル部分 */}
      <GContainer>
        <GItem xs={12}>
          <SectionText>{translate('facilityReservationTodayConditionInput.section.defecation')}</SectionText>
          <BlackDivider />
        </GItem>
      </GContainer>
      {/* フォーム部分 */}
      <Stack spacing={2}>
        {todayConditionInputFieldsInfo &&
          todayConditionInputFieldsInfo.defecation !== todayConditionInputFieldUsage.noUse && (
            <>
              {/* いつ排便をしましたか */}
              <GItem>
                <TitleLabel>
                  {todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary && (
                    <AttentionLabel>*</AttentionLabel>
                  )}
                  {translate('facilityReservationTodayConditionInput.form.label.defecationTiming')}
                </TitleLabel>
                <GContainer alignItems="flex-end">
                  <GItem xs={12}>
                    <Select
                      fullWidth
                      name={'defecationTiming'}
                      label={translate('facilityReservationTodayConditionInput.form.label.defecationTiming')}
                      valueLabels={defecationTimingValueLabels}
                      required={todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary}
                      control={control}
                    />
                  </GItem>
                </GContainer>
              </GItem>

              {/* 排便時刻 */}
              {defecationTiming === todayConditionDefecationTiming.yesterday && (
                <GItem>
                  <TitleLabel>
                    {todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary &&
                      defecationTiming === todayConditionDefecationTiming.yesterday && (
                        <AttentionLabel>*</AttentionLabel>
                      )}
                    {translate('facilityReservationTodayConditionInput.form.label.defecationHours.field')}
                  </TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <GContainer alignItems="flex-end">
                        <GItem xs={1}>
                          <NumberBox
                            name={'defecationHours'}
                            label={translate('facilityReservationTodayConditionInput.form.label.defecationHours.field')}
                            max={23}
                            min={0}
                            placeholder={'12'}
                            required={
                              todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary &&
                              defecationTiming === todayConditionDefecationTiming.yesterday
                            }
                            control={control}
                          />
                        </GItem>
                        <GItem xs="auto" style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}>
                          {translate('facilityReservationTodayConditionInput.form.label.defecationHours.unit')}
                        </GItem>
                      </GContainer>
                    </GItem>
                  </GContainer>
                </GItem>
              )}

              {/* 排便日 */}
              {defecationTiming === todayConditionDefecationTiming.twoDaysAgoOrLater && (
                <GItem>
                  <TitleLabel>
                    {todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary &&
                      defecationTiming === todayConditionDefecationTiming.twoDaysAgoOrLater && (
                        <AttentionLabel>*</AttentionLabel>
                      )}
                    {translate('facilityReservationTodayConditionInput.form.label.defecationDaysAgo.field')}
                  </TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <GContainer alignItems="flex-end">
                        <GItem xs={1}>
                          <NumberBox
                            name={'defecationDaysAgo'}
                            label={translate(
                              'facilityReservationTodayConditionInput.form.label.defecationDaysAgo.field'
                            )}
                            max={31}
                            min={1}
                            placeholder={'3'}
                            required={
                              todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary &&
                              defecationTiming === todayConditionDefecationTiming.twoDaysAgoOrLater
                            }
                            control={control}
                          />
                        </GItem>
                        <GItem xs="auto" style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}>
                          {translate('facilityReservationTodayConditionInput.form.label.defecationDaysAgo.unit')}
                        </GItem>
                      </GContainer>
                    </GItem>
                  </GContainer>
                </GItem>
              )}

              {/* 便の状態 */}
              <GItem>
                <TitleLabel>
                  {todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary && (
                    <AttentionLabel>*</AttentionLabel>
                  )}
                  {translate('facilityReservationTodayConditionInput.form.label.defecationCondition')}
                </TitleLabel>
                <GContainer alignItems="flex-end">
                  <GItem xs={12}>
                    <Select
                      fullWidth
                      name={'defecationCondition'}
                      label={translate('facilityReservationTodayConditionInput.form.label.defecationCondition')}
                      valueLabels={defecationConditionValueLabels}
                      required={todayConditionInputFieldsInfo.defecation === todayConditionInputFieldUsage.necessary}
                      control={control}
                    />
                  </GItem>
                </GContainer>
              </GItem>
            </>
          )}
      </Stack>
    </GItem>
  )
}

export default DefecationSec
